import type { RadioOption } from "../components/forms/Radio";

export const LocationOptions: RadioOption<boolean>[] = [
  { iconType: "Online", label: "Online", value: true },
  { iconType: "InPerson", label: "In Person", value: false },
];
